<template>
  <div
    class="container"
    :class="className"
    :style="containerSyle"
    v-on="!!redirectPathName ? { click: handleClick } : {}"
  >
    <div class="icon" v-if="iconName !== '' && !isPicture" :style="iconStyle">
      <BaseIcon :name="iconName" :width="iconWidth" :height="iconHeight" />
    </div>
    <div class="icon" v-if="isPicture" :style="iconStyle">
      <!-- @slot The content container of image display  -->
      <slot name="image"></slot>
    </div>
    <div class="text-container">
      <div class="textTitle" :class="textTitleClass" :style="labelStyle">
        {{ textTitle }}
        <span v-if="tooltipTitleText">
          <BaseIcon
            name="info"
            v-tooltip:bottom="{
              content: tooltipTitleText,
              disabled: false,
            }"
            width="12px"
            height="12px"
            class="info-btn"
          />
        </span>
      </div>
      <div
        class="textVal"
        :class="[textValColor]"
        :style="{
          fontSize: fontSize,
          height: textValHeight,
          lineHeight: lineHeight,
        }"
        v-if="!loading"
      >
        {{ textValue || 0 }}

        <div class="subtextVal" v-if="showSubTextValue">
          /{{ subtextVal || 0 }}
        </div>
        <div class="subTextLabel" v-if="subTextLabel">
          {{ subTextLabel }}
        </div>
      </div>
      <Loading v-if="loading" :smallar="true" />
      <div class="textLabel" :class="textLabelClass">
        {{ textLabel }}
        <span v-if="tooltipText">
          <BaseIcon
            name="infofilledv2sm"
            v-tooltip:bottom="{
              content: tooltipText,
              disabled: false,
            }"
          />
        </span>
      </div>
    </div>
    <slot name="actions"></slot>
  </div>
</template>
<script>
import Loading from '@/rex-components/rex-loading.vue';

/**
 * Info status is used to display icon and text together with label.
 */
export default {
  components: {
    Loading,
  },
  props: {
    /**
     *
     *To display Text Value
     *
     */
    textValue: {},
    /**
     *
     *Boolean condition to display subtext value
     *
     */
    showSubTextValue: { type: Boolean, default: false },
    /**
     *
     *To display sub text Value
     *
     */
    subtextVal: { type: String, default: '' },
    /**
     *
     *To display Sub Text Value
     *
     */
    subTextLabel: { type: String, default: '' },
    /**
     *
     *To display label under Text Value
     *
     */
    textLabel: { type: String },
    /**
     *
     *Icon name to render icon
     *
     */
    iconName: { type: String, default: '' },
    /**
     *
     *To set height of the icon
     *
     */
    iconHeight: { type: String },
    /**
     *
     *To set width of the icon
     *
     */
    iconWidth: { type: String },
    /**
     *
     *Color of text value
     *
     */
    textValColor: { type: String, default: 'fair' },
    /**
     *
     *Class name of root div
     *
     */
    className: { type: String, default: 'bg-dark-black' },
    /**
     *
     *Boolean set true when image/picture is passed as slot
     *
     */
    isPicture: { type: Boolean, default: false },
    /**
     *
     *Style object to modify container css
     *
     */
    containerSyle: { type: Object, default: () => ({}) },
    /**
     *
     *Style object to modify icon css
     *
     */
    iconStyle: { type: Object, default: () => ({}) },
    /*
     *
     * sub text Label styles
     */
    subtextLabelClass: { type: String, default: '' },
    /*
     *
     * text Label styles
     */
    textLabelClass: { type: String, default: '' },
    /**
     * text value style
     */
    textValueClass: { type: String, default: '0.8rem' },
    /**
     * label style
     */
    labelStyle: { type: Object, default: () => {} },
    /**
     * value style
     */
    valueStyle: { type: Object, default: () => {} },
    /**
     *
     *Redirection path name
     *
     */
    redirectPathName: { type: String, default: '' },
    /**
     *
     *
     *
     */
    loading: { type: Boolean, default: false },
    /**
     * tootltip next to textLabel
     */
    tooltipText: { type: String, default: '', required: false },
    /**
     * tootltip next to textLabel
     */
    tooltipTitleText: { type: String, default: '', required: false },
    /**
     * fontsize for textValue
     */
    fontSize: { type: String, default: '' },
    /**
     * textValue container height
     */
    textValHeight: { type: String, default: '' },
    /**
     * line hight for textValue
     */
    lineHeight: { type: String, default: '' },
    /**
     *
     *To display Title above Text Value
     *
     */
    textTitle: { type: String, default: '' },
    /*
     *
     * text Title styles
     */
    textTitleClass: { type: String, default: '' },
  },
  computed: {
    texLabel() {
      if (Array.isArray(this.textLabel)) {
        return this.textLabel[0];
      } else {
        return this.textLabel;
      }
    },
  },
  methods: {
    handleClick() {
      this.$router.push({
        name: this.redirectPathName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 1rem;
}
.bg-dark-black {
  background-color: $bg-dark-black;
}
.bg-secondary-color {
  background-color: $bg-secondary;
}
.text-container {
  @include flex-column;
}
.textVal {
  display: flex;
  flex-direction: row;
  text-align: left;
  font-size: 1.938rem;
}
.subtextVal {
  display: flex;
  font-size: 60%;
  color: $color-white;
  align-self: flex-end;
  padding-left: 0.1rem;
  padding-bottom: 0.3rem;
  flex-shrink: 0;
}
.textLabel {
  margin-top: -0.313rem;
  text-align: left;
  font-size: 80%;
}
.subTextLabel {
  padding-left: 0.3rem;
  padding-bottom: 0.35rem;
  align-self: flex-end;
  font-size: 50%;
  color: $table-header-text-grey;
}
.textTitle {
  margin-bottom: 0.313rem;
  text-align: left;
  font-size: 80%;
}
.fair {
  color: $color-brand-accent;
}
.poor {
  color: $poor;
}
.good {
  color: $good;
}
.white {
  color: $color-white;
}
.grey {
  color: rgba(255, 255, 255, 0.7);
}
.icon {
  margin-right: 1.25rem;
  margin-top: 0.938rem;
  margin-left: 0.1rem;
}
.image {
  margin-right: 1.25rem;
  margin-top: 0.938rem;
  height: 1rem;
  width: 1rem;
  object-fit: contain;
}
.info-card-cls {
  font-size: 1.2rem !important;
}
.tangerine {
  color: $color-brand-accent;
}
.info-btn {
  @include svg-fill-pointer($color-icon-grey);
}
</style>
